

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TeacherCreateDto, TeacherDto } from '../../Manipulate/CoursesObjects/TeacherDto';

@Injectable({
  providedIn: 'root'
})
export class TeacherService{
  private apiUrl = environment.apiUrl + '/teacher';

  constructor(private http: HttpClient) { }

  public AddTeacher(dto: TeacherCreateDto): Observable<any>{
    return this.http.post<any>(`${this.apiUrl}`,dto);
  }
  public ProfilePhoto(teacherId:string, form:FormData) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/profilePhoto/${teacherId}`, form);
  }
  public ListTeachers() : Observable<any>{
    return this.http.get(`${this.apiUrl}`);
  }
  public Edit(dto: TeacherDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${dto.id}`, dto);
  }
  public Delete(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }


}
